/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import { AndroidProto } from './android-proto';
import { IOSProto } from './iosproto';
import { MobileMockProto } from './mobile-mock-proto';

export enum PlatformUnion {
  NONE = 0,
  IOSProto = 1,
  AndroidProto = 2,
  MobileMockProto = 3,
}

export function unionToPlatformUnion(
  type: PlatformUnion,
  accessor: (
    obj: AndroidProto | IOSProto | MobileMockProto,
  ) => AndroidProto | IOSProto | MobileMockProto | null,
): AndroidProto | IOSProto | MobileMockProto | null {
  switch (PlatformUnion[type]) {
    case 'NONE':
      return null;
    case 'IOSProto':
      return accessor(new IOSProto())! as IOSProto;
    case 'AndroidProto':
      return accessor(new AndroidProto())! as AndroidProto;
    case 'MobileMockProto':
      return accessor(new MobileMockProto())! as MobileMockProto;
    default:
      return null;
  }
}

export function unionListToPlatformUnion(
  type: PlatformUnion,
  accessor: (
    index: number,
    obj: AndroidProto | IOSProto | MobileMockProto,
  ) => AndroidProto | IOSProto | MobileMockProto | null,
  index: number,
): AndroidProto | IOSProto | MobileMockProto | null {
  switch (PlatformUnion[type]) {
    case 'NONE':
      return null;
    case 'IOSProto':
      return accessor(index, new IOSProto())! as IOSProto;
    case 'AndroidProto':
      return accessor(index, new AndroidProto())! as AndroidProto;
    case 'MobileMockProto':
      return accessor(index, new MobileMockProto())! as MobileMockProto;
    default:
      return null;
  }
}
